import * as types from "../actions/actionsTypes";
import initialState from "./initialState";

export default function categoryDataReducer(
  state = initialState.categoryData,
  action
) {
  switch (action.type) {
    case types.LOADED_CATEGORY_DATA_SUCCESS:
      return action.categoryData;
    default:
      return state;
  }
}
